import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '@zz2/zz2-ui';

export default class RightActions {
    public static setIsLoading = createAction('RIGHT_SET_LOADING', withPayloadType<boolean>());
    public static reset = createAction('RIGHT_RESET');
}
